// Sostituire lo stato sopra con uno di quelli sotto
export const CLOUD_STATUS_OK = 0;
export const CLOUD_STATUS_MAINTENANCE = 1;
export const SERVICE_STATUS_POLL_INTERVAL_MS = 120000;

/** Query param `app` per l'endpoint service status. */
export const SERVICE_STATUS_APP = 'frontend';

/** Intervallo di polling dello stato cloud (ms). */
export const MAINTENANCE_POLLING_INTERVAL_MS = 120_000;

/**
 * True se lo status cloud indica manutenzione (Status !== 0).
 * L'endpoint è configurato in `environment.apiStatus`.
 */
export function isCloudInMaintenance(status: number | null | undefined): boolean {
	return (status ?? CLOUD_STATUS_OK) > CLOUD_STATUS_OK;
}

/** Rotte consultabili senza login: non innescare logout da manutenzione. */
export function isUnauthenticatedPublicRoute(url: string): boolean {
	const path = url.split('?')[0];
	return path.includes('/login')
		|| path.includes('/signup')
		|| path === '/public'
		|| path.startsWith('/public/');
}
